import React from "react";
import Box from "@mui/material/Box";
import {useAuth} from "../../../hooks/useAuth";
import PageTitle from "../../../shared/ui/PageTitle";
import BoxContent from "../../../shared/ui/BoxContent";
import StudentWorkPlan from "../components/StudentWorkPlan";

const StudentWorkPlanPage = () => {
    const {user} = useAuth();

    return (
        <Box component="main">
            <PageTitle>Planuri de lucru</PageTitle>
            <BoxContent>
                <StudentWorkPlan studentId={user.id}/>
            </BoxContent>
        </Box>
    )
}

export default StudentWorkPlanPage;